import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { couponApi } from '../../api';
import { useAuthStore } from '../../store/authStore';

interface WelcomeStatus {
  active: boolean;
  couponName?: string;
  discountType?: 'FIXED' | 'PERCENTAGE';
  discountValue?: number;
  minOrderAmount?: number | null;
  alreadyClaimed: boolean;
  hasPaidOrder: boolean;
  claimable: boolean;
}

const WelcomeCouponEvent: React.FC = () => {
  const { user } = useAuthStore();
  const navigate = useNavigate();
  const [status, setStatus] = useState<WelcomeStatus | null>(null);
  const [loading, setLoading] = useState(true);
  const [claiming, setClaiming] = useState(false);
  const [claimed, setClaimed] = useState(false);

  const load = () => {
    if (!user) { setLoading(false); return; }
    setLoading(true);
    couponApi.getWelcomeStatus()
      .then(r => setStatus(r.data.data as WelcomeStatus))
      .catch(() => setStatus(null))
      .finally(() => setLoading(false));
  };
  useEffect(() => { load(); }, [user]);

  const claim = async () => {
    setClaiming(true);
    try {
      await couponApi.claimWelcome();
      setClaimed(true);
      load();
    } catch (e: any) {
      alert(e.response?.data?.message || 'Failed to issue the coupon.');
    } finally {
      setClaiming(false);
    }
  };

  const isClaimed = claimed || status?.alreadyClaimed;
  const eventOff = status != null && !status.active;

  const onButtonClick = () => {
    if (claiming) return;
    if (!user) { navigate('/login'); return; }
    if (loading) return;
    if (eventOff) { alert('There is no active event right now.'); return; }
    if (isClaimed) { alert('You have already claimed this coupon.'); return; }
    if (!status?.hasPaidOrder) {
      if (window.confirm('You can claim this coupon after your first purchase. Go shopping now?')) {
        navigate('/products');
      }
      return;
    }
    if (status?.claimable) { claim(); return; }
    alert('This coupon is not available for your account.');
  };

  return (
    <div style={s.wrap}>
      <div style={s.banner}>
        <img src="/welcome-event.png" alt="First Purchase Thank-You Coupon event" style={s.img} />
        {/* "GET MY COUPON" 버튼 위치에 맞춘 클릭 영역 */}
        <button
          type="button"
          style={s.hit}
          onClick={onButtonClick}
          aria-label="Claim coupon"
        />
        {claiming && <div style={s.hitLabel}>Claiming...</div>}
        {isClaimed && <div style={{ ...s.hitLabel, ...s.hitDone }}>Claimed ✓</div>}
      </div>

      {isClaimed && (
        <Link to="/mypage" style={s.subLink}>View my coupons in My Page →</Link>
      )}
    </div>
  );
};

const s: Record<string, React.CSSProperties> = {
  wrap: { maxWidth: 440, margin: '0 auto', textAlign: 'center' },
  banner: { position: 'relative', display: 'block', lineHeight: 0 },
  img: { width: '100%', height: 'auto', display: 'block', borderRadius: 16 },
  // 배너 내 "GET MY COUPON" 버튼 영역 (세로 71.3~76.7%, 가로 25~75%)
  hit: {
    position: 'absolute', left: '25%', width: '50%', top: '71.3%', height: '5.4%',
    background: 'transparent', border: 'none', borderRadius: 999, cursor: 'pointer', padding: 0,
  },
  hitLabel: {
    position: 'absolute', left: '25%', width: '50%', top: '71.3%', height: '5.4%',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    background: 'rgba(123,97,194,0.92)', color: '#fff', borderRadius: 999,
    fontSize: 15, fontWeight: 800, pointerEvents: 'none',
  },
  hitDone: { background: 'rgba(76,175,80,0.95)' },
  subLink: { display: 'inline-block', marginTop: 18, color: '#7b61c2', fontWeight: 700, fontSize: 14, textDecoration: 'none' },
};

export default WelcomeCouponEvent;
